import { ChatterPost } from './types';

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * 1024;

export function formatFileSize(bytes: number) {
  if (bytes >= BYTES_PER_MB) {
    return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
  }
  return `${Math.max(1, Math.round(bytes / BYTES_PER_KB))} KB`;
}

// An @mention is a run of capitalised words joined by spaces only, so it can't run onto the next line.
const MENTION_PATTERN = /@(LE Design Team|[A-Z][A-Za-z0-9.'-]*(?: +\([^)]+\))?(?: +[A-Z][A-Za-z0-9.'-]*)*)/g;
const HASHTAG_PATTERN = /(^|\s)#([A-Za-z][A-Za-z0-9/&+-]*)/g;

export const CHATTER_MENTION_CLASS = 'chatter-mention';
export const CHATTER_HASHTAG_CLASS = 'chatter-hashtag';

export function highlightMentionsAndHashtags(markdown: string) {
  return markdown
    .replace(HASHTAG_PATTERN, `$1<span class="${CHATTER_HASHTAG_CLASS}">#$2</span>`)
    .replace(MENTION_PATTERN, `<span class="${CHATTER_MENTION_CLASS}">@$1</span>`);
}

const ACTIVE_MENTION_PATTERN = /(?:^|\s)@([^@\n]{0,30})$/;

export function findActiveMention(text: string, caret: number) {
  const match = ACTIVE_MENTION_PATTERN.exec(text.slice(0, caret));
  if (!match) {
    return null;
  }
  return { query: match[1], start: caret - match[1].length - 1 };
}

export function getCreatedTime(post: ChatterPost) {
  return new Date(post.createdAt).getTime();
}

export function getLastActivityTime(post: ChatterPost) {
  return Math.max(getCreatedTime(post), ...post.comments.map((comment) => new Date(comment.createdAt).getTime()));
}

export function getInitials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
}
